export const cardHeightUI = 250;
export const cardWidthUI = 187.5;

export const stepStackedCardY = 0.24;
export const stepStackedCardYFiber = stepStackedCardY / 2;
